import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useGrowerTagsList() {
    const toast = useToast()
    const records = ref(null)

    // Table Handler
    const columns = [
        { key: 'name', label: 'Name', sortable: false },
        { key: 'code', label: 'Code', sortable: false },
        { key: 'number', label: 'Number', sortable: false },
        {
            key: 'farmers', label: 'Growers', sortable: false, thClass: 'text-right', tdClass: 'text-right',
        },
        {
            key: 'hectares', label: 'Hectares', sortable: false, thClass: 'text-right', tdClass: 'text-right',
        },
        {
            key: 'volume', label: 'Est KGs', sortable: false, thClass: 'text-right', tdClass: 'text-right',
        },
        {
            key: 'requiredTags', label: 'Req Tags', sortable: false, thClass: 'text-right', tdClass: 'text-right',
        },
        {
            key: 'generatedTags', label: 'Gen Tags', sortable: false, thClass: 'text-right', tdClass: 'text-right',
        },
        {
            key: 'extra', label: 'Extra', sortable: false, thStyle: { width: '8%' }, thClass: 'text-right', tdClass: 'text-right',
        },
        {
            key: 'actions', label: 'Action', sortable: false, thStyle: { width: '15%' }, thClass: 'text-right', tdClass: 'text-right',
        },
    ]

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('name')
    const isSortDirDesc = ref(false)
    const locationFilter = ref(null)
    const society_id = ref(null)

    const refetch = () => {
        records.value.refresh()
    }

    watch([locationFilter, society_id, currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        store.dispatch('cromis-tags/list', {
            location_id: locationFilter.value,
            society_id: society_id.value,
            query: searchQuery.value,
            per_page: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        }).then(response => {
            const { tags, meta } = response.data

            meta.value = meta

            callback(tags)
            totalRecords.value = meta.value.total
            from.value = meta.value.from
            to.value = meta.value.to
        })
            .catch(error => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching tags list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    // *===============================================---*
    // *--------- UI ---------------------------------------*
    // *===============================================---*

    const resolveGrowerTypeVariant = society => {
        if (society !== null) return 'success'
        return 'primary'
    }

    const resolveStatusVariant = type => {
        if (type === 1) return 'success'
        if (type === 2) return 'secondary'
        return 'warning'
    }

    const resolveReceivedVariant = received => {
        if (received == true) return 'success'
        if (received == false) return 'secondary'
        return 'warning'
    }

    return {
        fetch,
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,

        // resolveUserRoleVariant,
        // resolveUserRoleIcon,
        resolveGrowerTypeVariant,
        resolveStatusVariant,
        refetch,
        resolveReceivedVariant,
        // Extra Filters
        // roleFilter,
        // planFilter,
        // statusFilter,
        locationFilter,
        society_id,
    }
}
